import { z } from "zod";

// `url` and `photoUrl` flow into <a href> / CSS url(...); reject javascript:,
// data: and friends.
const httpUrl = z.string().regex(/^https?:\/\//i);

export const OpenPlaySessionSchema = z.object({
  sessionId: z.string().min(1),
  sport: z.string().min(1),
  level: z.string().min(1),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // facility-local YYYY-MM-DD
  startTime: z.string().regex(/^\d{2}:\d{2}$/), // facility-local HH:MM
  when: z.string(),
  price: z.string(), // "$25.00 per player"
  pricePerPlayerCents: z.number(),
  spotsLeft: z.number(),
  url: httpUrl, // the "Confirm your spot" screen
});

export const OpenPlayFacilitySchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  city: z.string(),
  state: z.string(),
  distance: z.number().nullable(),
  photoUrl: httpUrl.nullable().optional(),
  // Average review score, 0-5. Not sent yet; the card shows a chip once it is.
  rating: z.number().min(0).max(5).nullable().optional(),
  url: httpUrl,
  sessions: z.array(OpenPlaySessionSchema).min(1),
});

export type OpenPlaySession = z.infer<typeof OpenPlaySessionSchema>;
export type OpenPlayFacility = z.infer<typeof OpenPlayFacilitySchema>;

/** One bad facility drops itself, not the whole row — same as availability. */
export function validateOpenPlayResult(value: unknown): OpenPlayFacility[] {
  const facilities = (value as { facilities?: unknown } | null)?.facilities;
  if (!Array.isArray(facilities)) return [];
  return facilities.flatMap((raw) => {
    const parsed = OpenPlayFacilitySchema.safeParse(raw);
    return parsed.success ? [parsed.data] : [];
  });
}
